import axios from "axios";
import { PPD_CONTRACT_HOURS, PPD_CONTRACT_HOURS_SAVE, SET_ERROR } from "../../types";

export const getContractHours = (company, payload) => {
    return async dispatch => {
        await axios.get(`api/ppd/contract-hours/${company}`, {
            params: payload
        }).then(res => {
            dispatch({
                type: PPD_CONTRACT_HOURS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const saveContractHours = (payload) => {
    return async dispatch => {
        await axios.post('api/ppd/save-contract-hours', payload).then(res => {
            dispatch({
                type: PPD_CONTRACT_HOURS_SAVE,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}